import { Controller } from "@hotwired/stimulus";

import { reloadFrame } from "../lib/frames.js";
import { patch } from "../lib/http.js";
import { showToast } from "../lib/toast.js";

/**
 * Карточка книги на полке.
 *
 * Сама карточка умеет только начать чтение; статус, формат, наличие, объём
 * и даты живут в шторке, а прогресс — в своей модалке. Карточка сообщает им
 * о себе событием, поэтому знать друг о друге им не нужно.
 *
 * Смена статуса меняет и кнопки карточки, и прогресс, поэтому после неё
 * перезагружается фрейм полки — прежний код перерисовывал карточку руками
 * и уже разошёлся с вёрсткой.
 */
export default class extends Controller {
  static values = {
    id: String,
    page: Number,
    total: Number,
    frame: { type: String, default: "shelf-list" },
  };

  /** Начать или возобновить чтение. */
  async startReading(event) {
    event.preventDefault();

    try {
      await patch(`/api/shelf/books/${this.idValue}`, { status: "reading" });
    } catch (error) {
      showToast(error.message);
      return;
    }

    showToast("Чтение начато", "success");
    this.reloadShelf();
  }

  openProgress(event) {
    event.preventDefault();
    this.dispatch("progress", {
      detail: {
        bookshelfId: this.idValue,
        title: this.title,
        page: this.pageValue,
        total: this.totalValue || null,
      },
    });
  }

  openSheet(event) {
    event.preventDefault();
    this.dispatch("sheet", { detail: { bookshelfId: this.idValue, title: this.title } });
  }

  /** Название книги для подзаголовка модалки — оно уже есть в разметке. */
  get title() {
    return this.element.querySelector("a")?.getAttribute("aria-label") ?? "";
  }

  /** Полка внутри Turbo-фрейма; на публичной странице его нет. */
  reloadShelf() {
    reloadFrame(this.frameValue);
  }
}
